import React from 'react';
import moment from 'moment';

const Details = ({ data }) => {
  return <div className="row">
    <div className="col-lg-4">
      <ul className="list-group list-group-flush">
        <li className="list-group-item"><strong>Form ID:</strong> {data.id}</li>
        <li className="list-group-item">
          {data.status === 'SCHEDULED' && <>
            <strong>Form Available On:</strong>&nbsp;
            {data.availableOn === null ?
              'Immediately' : <><br />{moment.tz(data.availableOn.date, data.availableOn.timezone).local().format('LL [at] LT')}</>
            }
          </>
          }
          {data.status === 'CANCELED' && <>
            <strong>Sent At:</strong> {data.sentAt && moment.tz(data.sentAt.date, data.sentAt.timezone).local().format('l LT')}
          </>
          }
        </li>
      </ul>
    </div>
    <div className="col-lg-4">
      <ul className="list-group list-group-flush">
        {
          data.status === 'EXPIRED' ? <>
            <li className="list-group-item"><strong>Expired:</strong> {data.expiration && moment.tz(data.expiration.date, data.expiration.timezone).local().format('l LT')} </li>
            {data.sentAt &&
              <li className="list-group-item"> <strong>Sent At:</strong> {data.sentAt && moment.tz(data.sentAt.date, data.sentAt.timezone).local().format('l LT')} </li>
            }
          </>
            :
            data.status === 'CANCELED' ? <>
              <li className="list-group-item"><strong>Canceled By:</strong> {data.canceledBy && `${data.canceledBy.firstName} ${data.canceledBy.lastName}`} </li>
              <li className="list-group-item"><strong>Canceled At:</strong> {data.canceledAt && moment.tz(data.canceledAt.date, data.canceledAt.timezone).local().format('l LT')}</li>
            </>
              :
              data.status !== 'SCHEDULED' ? <>
                {!data.patientProfileId && !data.completedAt &&
                  <li className="list-group-item">Patient has not started.</li>
                }
                {data.patientProfileId && !data.completedAt &&
                  <li className="list-group-item">Patient has started, but not completed.</li>
                }
                {data.patientProfileId && data.completedAt &&
                  <li className="list-group-item"><strong>Completed On:</strong> {data.completedAt && moment.tz(data.completedAt.date, data.completedAt.timezone).local().format('l LT')}</li>
                }
                {data.uploadedAt &&
                  <li className="list-group-item"><strong>EHR Uploaded:</strong> {data.uploadedAt && moment.tz(data.uploadedAt.date, data.uploadedAt.timezone).local().format('l LT')}</li>
                }

                {data.sentAt &&
                  <li className="list-group-item"> <strong>Sent At:</strong> {data.sentAt && moment.tz(data.sentAt.date, data.sentAt.timezone).local().format('l LT')} </li>
                }
              </>
                :
                <>
                  <li className="list-group-item">&nbsp;</li>
                  <li className="list-group-item"></li>
                </>
        }
      </ul>
    </div>
    <div className="col-lg-4">
      <ul className="list-group list-group-flush">
        <li className="list-group-item"><strong>Scheduled By:</strong> {data.scheduledBy ? `${data.scheduledBy.firstName} ${data.scheduledBy.lastName}` : 'EHR'}</li>
        <li className="list-group-item"><strong>Scheduled On:</strong> {data.scheduledAt && moment.tz(data.scheduledAt.date, data.scheduledAt.timezone).local().format('l LT')}</li>
      </ul>
    </div>
  </div>
}

export default Details;